import React from "react";
import useBulkUpload from "../../customHooks/BulkUpload/useBulkUpload";
import { Button, Spinner } from "react-bootstrap";
import { DialogContent, DialogTitle } from "@mui/material";
import { Dialog, DialogActions, DialogContentText } from "@material-ui/core";
import { Loader as LoaderIcon } from "react-feather";
import { FaCheck } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";

import { IoIosArrowDropleft } from "react-icons/io";
import Pagination from "react-js-pagination";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import styles from "./Preview.module.css";
import classNames from "classnames";
import { useNavigate } from "react-router";

const TABLE_HEADINGS = ["Sku", "Product Name", "Image Name", "Image", "Tag"];

const Preview = () => {
  const hookProps = useBulkUpload();
  const navigate = useNavigate();
  const {
    uploadImages,
    handleClose,
    show,
    createstatus,
    imageLoader,
    tempImagesData,
    loadingTempImages,
    currentPage,
    totalPages,
    handlePageChange,
    totalSelection,
    handleAllSelection,
    showConfirmation,
    handleSubmit,
    submitionLoading,
    showError,
    uploadError,
    closeErrorDialog,
    handleSelected,
    viewType,
    setViewType,
    isModalOpen,
    modalImageUrl,
    closeModal,
    acceptLoader,
    rejectLoader,
    setAcceptLoader,
    setRejectLoader,
    openModal,
  } = hookProps;

  return (
    <>
      <div>
        <div className={styles.topheader}>
          <div className="flex justify-between">
            <span className={`p-1 ${styles.titlename}`}>Products</span>
            <div className="flex gap-10">
              <select
                id="viewType"
                name="viewType"
                value={viewType}
                className="p-2 border rounded-md"
                onChange={(e) => setViewType(e.target.value)}
              >
                <option value={"content"}>Content </option>
                {/* <option value={"list"}>List </option> */}
                <option value={"details"}>Details</option>
                <option value={"grid"}>Grid</option>
                <option value={"thumbnails"}>Thumbnails</option>
              </select>
              <button
                className={` ${styles.back}`}
                style={{ backgroundColor: "#646af5" }}
                onClick={() => navigate("/productsandbox")}
              >
                <IoIosArrowDropleft size={20} /> Go Back
              </button>
            </div>
          </div>
        </div>

        <div className={styles.middle_main_container}>
          <div className="">
            {loadingTempImages ? (
              <div className="screenTableRootLoader">
                <SmallLoader />
              </div>
            ) : tempImagesData && tempImagesData?.length > 0 ? (
              <>
                <div className={styles.containerWrapper}>
                  {viewType === "content" ? (
                    <div className={styles.tableWrapper}>
                      <table className="w-full border border-collapse">
                        <thead className="bg-gray-300 sticky top-0">
                          <tr>
                            <th className="p-2 w-[120px]">
                              <div className="inline-flex gap-1 items-center">
                                <input
                                  type="checkbox"
                                  value="PendingAll"
                                  id="PendingAll"
                                  onChange={(e) => {
                                    handleAllSelection(e, "pending");
                                  }}
                                  checked={tempImagesData
                                    ?.flatMap((product) =>
                                      JSON.parse(product.ImageJson).map(
                                        (image) => image.iTempProductGalleryId
                                      )
                                    )
                                    .every((id) => totalSelection.includes(id))}
                                />
                                <label
                                  className="m-0 cursor-pointer"
                                  htmlFor="PendingAll"
                                ></label>
                              </div>
                            </th>

                            {TABLE_HEADINGS.map((item, idx) => (
                              <th
                                className={classNames("p-2", {
                                  "w-52": item === "Tag",
                                })}
                                key={idx}
                              >
                                {item}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {tempImagesData.map((item) =>
                            JSON.parse(item?.ImageJson).map((child, cidx) => (
                              <tr key={child.iTempProductGalleryId}>
                                <th className="p-2 w-[120px]">
                                  <div className="inline-flex gap-1 items-center">
                                    <input
                                      type="checkbox"
                                      value="pending"
                                      id="pending"
                                      onChange={(e) => {
                                        handleSelected(
                                          e,
                                          child.iTempProductGalleryId
                                        );
                                      }}
                                      checked={totalSelection.includes(
                                        child.iTempProductGalleryId
                                      )}
                                    />
                                  </div>
                                </th>

                                {cidx === 0 && (
                                  <td
                                    rowSpan={JSON.parse(item.ImageJson).length}
                                    className="border p-2"
                                  >
                                    {item.ProductSKU}
                                  </td>
                                )}
                                {cidx === 0 && (
                                  <td
                                    rowSpan={JSON.parse(item.ImageJson).length}
                                    className="border p-2"
                                  >
                                    {item.ProductName}
                                  </td>
                                )}
                                <td className="border p-2">
                                  {child.sImageName}
                                </td>
                                <td className="border p-2">
                                  <img
                                    src={child.sURL}
                                    alt={child.name}
                                    width={80}
                                    height={80}
                                    className="w-full h-20 object-contain"
                                  />
                                </td>
                                <td className="border p-2">{child.sTag}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : null}

                  {viewType === "grid" ? (
                    <div className={styles.tableWrapper}>
                      <div className={styles.gridContainer}>
                        {tempImagesData.map((item) => {
                          const images = JSON.parse(item.ImageJson);

                          return images.map((child) => (
                            <div
                              key={child.iTempProductGalleryId}
                              className={styles.gridItem}
                            >
                              <div className={styles.checkboxContainer}>
                                <input
                                  type="checkbox"
                                  value="pending"
                                  id={`checkbox-${child.iTempProductGalleryId}`}
                                  onChange={(e) =>
                                    handleSelected(
                                      e,
                                      child.iTempProductGalleryId
                                    )
                                  }
                                  checked={totalSelection.includes(
                                    child.iTempProductGalleryId
                                  )}
                                />
                              </div>
                              <div className={styles.imageContainer}>
                                <img
                                  src={child.sURL}
                                  alt={child.sImageName}
                                  className={styles.image}
                                />
                              </div>
                              <div className={styles.productSKU}>
                                <strong>SKU:</strong>{" "}
                                <span>{item.ProductSKU}</span>
                              </div>
                              <div className={styles.productSKU}>
                                <strong>Tag:</strong> <span>{child.sTag}</span>
                              </div>
                            </div>
                          ));
                        })}
                      </div>
                    </div>
                  ) : null}

                  {viewType === "details" ? (
                    <div className={styles.tableWrapper}>
                      <table className={styles.customTable}>
                        <thead className="bg-gray-700 sticky top-0l">
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                value="PendingAll"
                                id="PendingAll"
                                onChange={(e) => {
                                  handleAllSelection(e, "pending");
                                }}
                                checked={tempImagesData
                                  .flatMap((product) =>
                                    JSON.parse(product.ImageJson).map(
                                      (image) => image.iTempProductGalleryId
                                    )
                                  )
                                  .every((id) => totalSelection.includes(id))}
                              />
                            </th>
                            <th>SKU</th>
                            <th>Product Name</th>
                            <th>Image Name</th>
                            <th>Image</th>
                            <th>Tag</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tempImagesData.map((item) => {
                            const images = JSON.parse(item.ImageJson);
                            return images.map((child, cidx) => (
                              <tr key={child.iTempProductGalleryId}>
                                <th className="p-2 w-[120px]">
                                  <div className="inline-flex gap-1 items-center">
                                    <input
                                      type="checkbox"
                                      value="pending"
                                      id="pending"
                                      onChange={(e) => {
                                        handleSelected(
                                          e,
                                          child.iTempProductGalleryId
                                        );
                                      }}
                                      checked={totalSelection.includes(
                                        child.iTempProductGalleryId
                                      )}
                                    />
                                  </div>
                                </th>
                                {cidx === 0 && (
                                  <td
                                    rowSpan={JSON.parse(item.ImageJson).length}
                                    className="border p-2"
                                  >
                                    {item.ProductSKU}
                                  </td>
                                )}
                                {cidx === 0 && (
                                  <td
                                    rowSpan={JSON.parse(item.ImageJson).length}
                                    className="border p-2"
                                  >
                                    {item.ProductName}
                                  </td>
                                )}

                                <td>{child.sImageName}</td>
                                <td>
                                  <img
                                    src={child.sURL}
                                    alt={child.sImageName}
                                    width={30} // Small icon size
                                    height={30}
                                    className={styles.imageIcon}
                                    onClick={() => openModal(child.sURL)}
                                  />
                                </td>
                                <td>
                                  <strong>{child.sTag}</strong>
                                </td>
                              </tr>
                            ));
                          })}
                        </tbody>
                      </table>

                      {isModalOpen && (
                        <div
                          className={styles.modalOverlay}
                          onClick={closeModal}
                        >
                          <div
                            className={styles.modalContent}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <img
                              src={modalImageUrl}
                              alt="Full view"
                              className={styles.modalImage}
                            />
                            <button
                              className={styles.closeButton}
                              onClick={closeModal}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : null}

                  {viewType === "thumbnails" ? (
                    <div className={styles.imageGridContainer}>
                      {tempImagesData.map((item) => {
                        const images = JSON.parse(item.ImageJson);
                        return images.map((image) => (
                          <div
                            key={image.iTempProductGalleryId}
                            className={styles.imageGridItem}
                          >
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                handleSelected(e, image.iTempProductGalleryId)
                              }
                              checked={totalSelection.includes(
                                image.iTempProductGalleryId
                              )}
                              id={`checkbox-${image.iTempProductGalleryId}`}
                              className={styles.imageCheckbox}
                            />
                            <img
                              src={image.sURL}
                              alt={image.sImageName}
                              className={styles.gridImage}
                            />
                          </div>
                        ));
                      })}
                    </div>
                  ) : null}

                  <div className="w-full flex items-center justify-between mt-auto">
                    <div className={`flex gap-4 ${styles.bottomButtom}`}>
                      {acceptLoader ? (
                        <button
                          className={`screenFormSubmitLoaderBtn consistentBtn ${styles.modalbtn}`}
                          style={{ width: "100px" }}
                          disabled={acceptLoader}
                        >
                          <LoaderIcon size={20} className="indicator" />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className={`flex items-center gap-2 px-4 py-2 text-gray-800 border border-gray-300 rounded hover:bg-gray-100 cursor-pointer ${styles.modalbtnfirst}`}
                          onClick={() =>
                            handleSubmit("accept", setAcceptLoader)
                          }
                          disabled={!totalSelection.length}
                        >
                          Accept
                          <span>
                            <FaCheck />
                          </span>
                        </button>
                      )}
                      {rejectLoader ? (
                        <button
                          className={`screenFormSubmitLoaderBtn consistentBtn ${styles.modalbtn}`}
                          style={{ width: "100px" }}
                          disabled={rejectLoader}
                        >
                          <LoaderIcon size={20} className="indicator" />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className={`flex items-center gap-2 px-4 py-2 text-gray-800 border border-gray-300 rounded hover:bg-gray-100 cursor-pointer ${styles.modalbtnSecond}`}
                          onClick={() =>
                            handleSubmit("reject", setRejectLoader)
                          }
                          disabled={!totalSelection.length}
                        >
                          Reject
                          <span className="text-red-600">
                            <IoCloseOutline />
                          </span>
                        </button>
                      )}
                    </div>

                    <div>
                      {totalPages > 10 && (
                        <Pagination
                          activePage={currentPage}
                          itemsCountPerPage={10}
                          totalItemsCount={totalPages}
                          pageRangeDisplayed={1}
                          onChange={handlePageChange}
                          nextPageText={"next"}
                          prevPageText={"prev"}
                          firstPageText={"<<"}
                          lastPageText={">>"}
                          itemClass="page-item"
                          linkClass="page-link"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p>No Data Found</p>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={show}
        onClose={() => {
          if (!imageLoader) {
            handleClose();
          }
        }}
      >
        <DialogTitle className="newpopupstyle"></DialogTitle>
        <DialogContent>
          <DialogContentText>{createstatus}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            className="bg-red-600 w-24 hover:bg-red-700"
            disabled={imageLoader}
          >
            Cancel
          </Button>
          <Button
            onClick={uploadImages}
            color="success"
            className={classNames("w-24", {
              "screenFormSubmitLoaderBtn consistentBtn w-24": imageLoader,
            })}
            disabled={imageLoader}
          >
            {imageLoader ? (
              <LoaderIcon size={20} className="indicator" />
            ) : (
              "Yes"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showError} onClose={closeErrorDialog}>
        <DialogTitle className="newpopupstyle">Error</DialogTitle>
        <DialogContent>
          <DialogContentText>{uploadError?.msg}</DialogContentText>
          {uploadError.errors.length > 0 ? (
            <ul className="max-h-[230px] overflow-y-auto">
              {uploadError.errors.map((item, index) => (
                <li key={index} className="flex space-x-4 pb-2.5">
                  <img
                    src={URL.createObjectURL(item)}
                    alt="preview"
                    className="w-16 h-16 object-cover rounded"
                  />
                  <div>
                    <p className="text-sm">{item.name}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeErrorDialog}
            className="bg-red-600 w-24 hover:bg-red-700"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showConfirmation} onClose={handleClose}>
        <DialogTitle className="newpopupstyle"></DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to submit?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            className="bg-red-600 hover:bg-red-700"
            disabled={submitionLoading}
          >
            {submitionLoading ? (
              <Spinner animation="border" variant="light" />
            ) : (
              "Cancel"
            )}
          </Button>
          <Button
            onClick={handleSubmit}
            color="success"
            disabled={submitionLoading}
          >
            {submitionLoading ? (
              <Spinner animation="border" variant="light" />
            ) : (
              "Yes"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Preview;
